import {
  Product,
  RawOrder,
  RestaurantSetting,
  ShopSettingDeliveryCity,
  TableStatus,
} from "@lemmonhq/types";
export const round = (num: number) => parseFloat(num.toFixed(2));

export const humanize = (value: string) => {
  const camelMatch = /([A-Z])/g;
  const underscoreMatch = /_/g;
  const camelCaseToSpaces = value.replace(camelMatch, " $1");
  const underscoresToSpaces = camelCaseToSpaces.replace(underscoreMatch, " ");
  const caseCorrected =
    underscoresToSpaces.charAt(0).toUpperCase() +
    underscoresToSpaces.slice(1).toLowerCase();
  return caseCorrected;
};

export const truncateStaffName = (name: string) => {
  if (!name) return ``;
  const parts = name.split(" ");
  return `${parts[0]} ${parts[1] ? parts[1][0] : ""}`;
};

export const shortenStaffName = (name: string) => {
  if (!name) return ``;
  const parts = name.split(" ");
  return `${parts[0].slice(0, 3).toLocaleUpperCase()}`;
};

export const getDeliveryCities = (settings: RestaurantSetting[]) => {
  const setting = (settings || []).find((el) => el.key === "delivery_cities");
  if (setting) {
    return JSON.parse(setting.value as string) as ShopSettingDeliveryCity[];
  } else {
    return [];
  }
};

export const getOrderDisplayName = (
  order: RawOrder & { user: { name: string } },
) => {
  // todo: fix sql to not return user when user_id is null
  if (order.user?.id) {
    const name = order.user.name;
    return `${shortenStaffName(name)}-${order.display_id}`;
  } else {
    if (order.table_id) {
      return `QR-${order.display_id}`;
    } else if (order.service_method === "takeaway") {
      return `TAK-${order.display_id}`;
    } else if (order.service_method === "delivery") {
      return `DEL-${order.display_id}`;
    } else {
      return `WEB-${order.display_id}`;
    }
  }
};

export const isPackaged = !!(globalThis as any).ReactNativeWebView;
export const needsFetchBridge = isPackaged; //&& !navigator?.userAgent?.match(/android/gi);

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const searchProducts = (products: Product[], searchQuery: string) => {
  const query = searchQuery.toLowerCase().normalize("NFC");
  const list = products.filter((product) => {
    if (product.name) {
      const name = product.name.toLowerCase().normalize("NFC");
      // todo: use fuzzy search here
      return name.includes(query);
    }
  });
  console.log({ query, list });
  return list;
};

export const sortTables = (tables: TableStatus[]) => {
  return tables.sort((a, b) => {
    const a1 = parseInt(a.table.name.replace(/^\D+/g, "")) || 1000;
    const b1 = parseInt(b.table.name.replace(/^\D+/g, "")) || 1000;
    return a1 - b1;
  });
};

export function setTitle(title: string) {
  try {
    document.title = `${title} | Lemmon `;
  } catch (e) {
    // ssr
  }
}
